<div class="lg:re-min-h-350">
  <h4 [ngClass]="{'re-hidden': activeQuestion !== 0}" class="re-text-m">{{ 'feedback.dialog.title' | translate }}</h4>

  @if (activeQuestion < maxQuestions() && poll()) {
    <div>
      <div class="re-mb-10 re-mt-20">
        {{ 'satisfactionPoll.questionNumber' | translate:
        { currentQuestion: (activeQuestion + 1).toString(), maxQuestion: maxQuestions().toString() } }}
      </div>
      @if (activeQuestion >= 0) {
        <bdo-poll-question
          [questionData]="poll()?.questions[activeQuestion]"
          [pollId]="poll()?.pollId"
          (sendAnswer)="onQuestionComplete($event)"
        ></bdo-poll-question>
      }
    </div>
  } @else {
    <!-- make sure, that the bdo-poll-done doesn't flash up while loading the poll -->
    @if (activeQuestion !== 0) {
      <bdo-poll-done />
    }
  }
</div>
